import { InjectionToken } from "@angular/core";


export const USE_NX_TOOL_API = new InjectionToken<boolean>(
    'Determines if we should use the NX Tool service or use the static generatred depGraph json.',
    {
        providedIn: 'root',
        factory: () => false,
    }
);
